import { render, staticRenderFns } from "./MainNavItem.vue?vue&type=template&id=9da2c67a"
import script from "./MainNavItem.vue?vue&type=script&lang=ts"
export * from "./MainNavItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports